import axios from "axios";

import type { HealthCheckResponse } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client";

export async function healthcheckFn() {
	const response = await axios.get<HealthCheckResponse>(env.apiUrl);

	return response.data;
}

export const healthcheck = queryOptions({
	queryFn: healthcheckFn,
	queryKey: "healthcheck",
});

export async function ping() {
	return axios.get(`${env.apiUrl}/ping`);
}
